module.exports = __webpack_public_path__ + "img/Daikin_Header.c0a100a3.png";